import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { DashboardmainAdminComponent } from './dashboardmain-admin/dashboardmain-admin.component';
import { AddZoneAdminComponent } from './Manage-Zone-Admins/add-zone-admin/add-zone-admin.component';
import { ChangePwdAdminComponent } from './change-pwd-admin/change-pwd-admin.component';
import { ChartsModule } from 'ng2-charts';
import { AllClientsComponent } from './Manage-Clients/all-clients/all-clients.component';
import { ClientsDocumentsComponent } from './Manage-Clients/clients-documents/clients-documents.component';
import { ManageCategoryAdminComponent } from './Settings/manage-category-admin/manage-category-admin.component';
import { ViewContactUsAdminComponent } from './Settings/view-contact-us-admin/view-contact-us-admin.component';
import { ViewReferralHistoryAdminComponent } from './Settings/view-referral-history-admin/view-referral-history-admin.component';
import { ViewFileDownloadHistoryAdminComponent } from './Settings/view-file-download-history-admin/view-file-download-history-admin.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { LeadsHistoryAdminComponent } from './Settings/leads-history-admin/leads-history-admin.component';
import { LeadBulkUploadsAdminComponent } from './Manage-Leads/lead-bulk-uploads-admin/lead-bulk-uploads-admin.component';
import { AddLeadsAdminComponent } from './Manage-Leads/add-leads-admin/add-leads-admin.component';
import { ManageLeadsAdminComponent } from './Manage-Leads/manage-leads-admin/manage-leads-admin.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { DxDataGridModule, DxButtonModule, DxSelectBoxModule, DxChartModule } from 'devextreme-angular';
import { ManageZoneAdminComponent } from './Manage-Zone-Admins/manage-zone-admin/manage-zone-admin.component';
import { ManageReturnTaxComponent } from './return-tax/manage-return-tax/manage-return-tax.component';
import { UploadReturnTaxAdminComponent } from './return-tax/upload-return-tax-admin/upload-return-tax-admin.component';
import { WhislistsAdminComponent } from './whislists-admin/whislists-admin.component';

@NgModule({
  declarations: [ LoginAdminComponent, DashboardAdminComponent, DashboardmainAdminComponent, AddZoneAdminComponent, ChangePwdAdminComponent, AllClientsComponent, ClientsDocumentsComponent, ManageCategoryAdminComponent, ViewContactUsAdminComponent, ViewReferralHistoryAdminComponent, ViewFileDownloadHistoryAdminComponent, LeadsHistoryAdminComponent, LeadBulkUploadsAdminComponent, AddLeadsAdminComponent, ManageLeadsAdminComponent, ManageZoneAdminComponent, ManageReturnTaxComponent, UploadReturnTaxAdminComponent, WhislistsAdminComponent],
  imports: [
    DxButtonModule,
    RouterModule.forRoot([]),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    NgxDatatableModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    NgxSpinnerModule,
    DxDataGridModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxChartModule
  ]
})
export class AdminModule { }
